<template>
  <div class="mobile">
    <div class="down">
      <div style="height: 1px"></div>
      <div class="down-btn" @click="checkBrowser()"></div>
    </div>
    <img
      src="@/assets/images/14brsjb_02.jpg"
      width="640"
      height="821"
      class="main-img"
    />
    <img
      src="@/assets/images/14brsjb_03.jpg"
      width="640"
      height="821"
      class="main-img"
    />
    <img
      src="@/assets/images/14brsjb_04.jpg"
      width="640"
      height="821"
      class="main-img"
    />
    <img
      src="@/assets/images/14brsjb_05.jpg"
      width="640"
      height="922"
      class="main-img"
    />
    <div class="down2">
      <a class="down-btn" @click="goDownload(appleHref)"> </a>

      <a class="down-btn" @click="goDownload(androidHref)"> </a>
    </div>

    <div class="drawer-ryxly">
      <a href="http://ebook.pep.com.cn/ry/">日语训练营</a>
      <img src="@/assets/images/logo-ryxly.png" alt="日语训练营" />
    </div>
    <div class="weixin-tips" v-show="showVxTips" @click="showVxTips = false">
      <img src="@/assets/images/live_weixin.png" alt="" />
    </div>
  </div>
</template>

<script>
import { is_weixin, check_browser } from "@/utils";

export default {
  data() {
    return {
      showVxTips: false,
      androidHref: "https://ebookres.mypep.cn/biaori.apk",
      appleHref:
        "https://itunes.apple.com/us/app/xin-ban-zhong-ri-jiao-liu/id847327884?l=zh&ls=1&mt=8#",
    };
  },
  mounted() {},
  methods: {
    goDownload(address) {
      const isVx = is_weixin();
      if (isVx) {
        this.showVxTips = true;
      } else {
        location.href = address;
      }
    },
    checkBrowser() {
      const bro = check_browser();
      if (bro == "android") {
        this.goDownload(this.androidHref);
      } else {
        this.goDownload(this.appleHref);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile {
  width: 640px;
  margin: 0 auto;

  .weixin-tips {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      margin: 10% auto 0;
    }
  }

  .down {
    background: url("~@/assets/images/14brsjb_01.jpg") no-repeat;
    width: 640px;
    height: 1243px;
    .down-btn {
      margin: 330px 0 0 220px;
    }
  }
  .down2 {
    background: url("~@/assets/images/14brsjb_06.jpg") no-repeat;
    width: 640px;
    height: 375px;
    display: flex;
    justify-content: center;
    .down-btn {
      margin: 60px 20px 0;
    }
  }
  .main-img {
    object-fit: fill;
  }

  .down-btn {
    width: 220px;
    height: 70px;
    cursor: pointer;
  }
}

// 移动端响应式样式
@media (max-width: 768px) {
  .mobile {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 15px;

    .down {
      width: 100% !important;
      height: auto !important;
      min-height: 400px;
      background-size: 100% auto !important;
      background-position: center top !important;

      .down-btn {
        margin: 200px auto 0 !important;
        display: block !important;
        width: 180px !important;
        height: 60px !important;
      }
    }

    .down2 {
      width: 100% !important;
      height: auto !important;
      min-height: 300px;
      background-size: 100% auto !important;
      background-position: center !important;

      .down-btn {
        margin: 40px 15px 0 !important;
        width: 180px !important;
        height: 60px !important;
      }
    }

    .main-img {
      width: 100% !important;
      height: auto !important;
      object-fit: contain !important;
      margin-bottom: 20px !important;
    }

    .down-btn {
      width: 180px !important;
      height: 60px !important;
    }

    .drawer-ryxly {
      width: 120px !important;
      height: 35px !important;
      bottom: 30px !important;
      left: -70px !important;

      img {
        width: 35px !important;
        height: 35px !important;
        margin: 0 3px !important;
      }

      a {
        font-size: 14px !important;
      }
    }

    .weixin-tips {
      img {
        width: 90% !important;
        height: auto !important;
        margin: 20% auto 0 !important;
      }
    }
  }
}
</style>
